/**
 * @param  {Object} state
 * @return {Object}
 */
export const OPTIONS = (state) => {
  return state;
};
